import gql from 'graphql-tag';
import MultilevelTaxonomyFragment from './MultilevelTaxonomy.gql';

export default gql`
  fragment RecipeItemFragment on RecipeItem {
    id
    type
    data {
      recipeId
      title
      description
      author {
        name
      }
      categories {
        name
      }
      keywords
      cuisines
      imageUrl
      serves
      makes
      notes
      cookTime {
        min
        max
      }
      prepTime {
        min
        max
      }
      ingredientGroups {
        id
        name
        items {
          id
          quantity
          unit
          html
        }
      }
      supplyGroups {
        id
        name
        items {
          id
          quantity
          unit
          html
          recipeSupplyItemId
        }
      }
      instructionGroups {
        id
        name
        items {
          id
          html
          imageUrl
        }
      }
      nutritionalGuide {
        calories
        servings
        labels
        primaryNutrients {
          label
          value
          quantity
          schemaValue
        }
      }
      course {
        ...MultilevelTaxonomyFragment
      }
      dishType {
        ...MultilevelTaxonomyFragment
      }
      meal {
        ...MultilevelTaxonomyFragment
      }
      cuisine {
        ...MultilevelTaxonomyFragment
      }
      method {
        ...MultilevelTaxonomyFragment
      }
      timing {
        ...MultilevelTaxonomyFragment
      }
      mainIngredients {
        ...MultilevelTaxonomyFragment
      }
      occasion {
        ...MultilevelTaxonomyFragment
      }
      lifestyle {
        ...MultilevelTaxonomyFragment
      }
      diet {
        ...MultilevelTaxonomyFragment
      }
    }
  }
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
  ${MultilevelTaxonomyFragment}
`;
